import { render, staticRenderFns } from "./AgregarEscenario.vue?vue&type=template&id=f15e6d56"
import script from "./AgregarEscenario.vue?vue&type=script&lang=js"
export * from "./AgregarEscenario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports